export default new class Accordion {
    constructor() {
        this.buttonTabClass = 'js-tab';
        this.initHandler();
    }

    initHandler() {
        window.addEventListener('load', () => {
            const $this = this
            const $select =  $(`select[name=tabs]`)
            const $tab =  $(`.${this.buttonTabClass}`)

            $tab.on('click', function () {
                $this.setSelect($(this))
            });
            $select.on('change', function () {
                $this.setSelect($(this))
            });
            // this.initHash();

        });
    }

    // initHash() {
    //     let hash = document.location.hash;
    //     if (hash && hash.length > 1) {
    //         hash = hash.slice(1);
    //         $(`.${this.buttonTabClass}[data-value=${hash}]`).click();
    //     }
    // }

    setSelect(ctx) {
        let tabIdent = ctx.is("select") ? ctx.val() : ctx.data("value");
        if (tabIdent && tabIdent.length) {
            let tabsBlock = ctx.parents(".js-tabs");
            tabsBlock.find("[data-tab]:not(.hidden)").addClass("hidden");
            tabsBlock.find("[data-tab=" + tabIdent + "]").removeClass("hidden");

            tabsBlock.find("div button").removeClass('text-indigo-600 border-indigo-500 hover:text-indigo-600 hover:border-indigo-500').addClass('text-gray-500 hover:text-gray-700 hover:border-gray-300')
            tabsBlock.find("div button[data-value=" + tabIdent + "]").addClass("text-indigo-600 border-indigo-500 hover:text-indigo-600 hover:border-indigo-500").removeClass('text-gray-500 hover:text-gray-700 hover:border-gray-300');

            tabsBlock.find("select[name=tabs] option").prop("selected", false);
            tabsBlock.find("select[name=tabs] option[value=" + tabIdent + "]").prop("selected", true);
        }
    }
}();
